import { render, staticRenderFns } from "./_Summary.vue?vue&type=template&id=5f8248a9&scoped=true&"
import script from "./_Summary.vue?vue&type=script&lang=js&"
export * from "./_Summary.vue?vue&type=script&lang=js&"
import style0 from "./_Summary.vue?vue&type=style&index=0&id=5f8248a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8248a9",
  null
  
)

export default component.exports